import { Organization } from "@/components/ui/signup/create-organization/CreateOrganizationInterfaces";
import axios from "axios";
import "firebase/auth";
import { getAuth } from "firebase/auth";


export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL
});


export const getUsersByOrganization = async (organizationId: string) => {
  const token = await getAuth().currentUser?.getIdToken()
  const response = await api.get(`/organizations/${organizationId}/users`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}


export const getOrganization = async (organizationId: string) => {
  const token = await getAuth().currentUser?.getIdToken()
  const response = await api.get(`/organizations/${organizationId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}


export const createOrganization = async (organizationData: Organization) => {
  const token = await getAuth().currentUser?.getIdToken()
  const response = await api.post(`/organizations/create`, organizationData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}


export const updateOrganization = async (organizationId: string, organizationData: Organization) => {
  const token = await getAuth().currentUser?.getIdToken()
  const response = await api.put(`/organizations/${organizationId}`, organizationData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export const deleteOrganization = async (organizationId: string) => {
  const token = await getAuth().currentUser?.getIdToken()
  const response = await api.delete(`/organizations/${organizationId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}